var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantages8({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 4.16669L12.5 20.8334V45.8334C12.5 68.9584 28.5 90.5834 50 95.8334C71.5 90.5834 87.5 68.9584 87.5 45.8334V20.8334L50 4.16669ZM50 29.1667C55.8333 29.1667 61.6667 33.75 61.6667 39.5834V45.8334C64.1667 45.8334 66.6667 48.3334 66.6667 51.25V65.8334C66.6667 68.3334 64.1667 70.8334 61.25 70.8334H38.3333C35.8333 70.8334 33.3333 68.3334 33.3333 65.4167V50.8334C33.3333 48.3334 35.8333 45.8334 38.3333 45.8334V39.5834C38.3333 33.75 44.1667 29.1667 50 29.1667ZM50 34.1667C46.6667 34.1667 43.75 36.25 43.75 39.5834V45.8334H56.25V39.5834C56.25 36.25 53.3333 34.1667 50 34.1667Z",
    fill: "url(#paint0_linear_341_1719)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_1719",
    x1: 6.5674,
    y1: 105.51,
    x2: 104.697,
    y2: 19.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantages8);
export default __webpack_public_path__ + "static/media/advantages_8.a7c5ae2358f9710bb4fd2b31551ae989.svg";
export { ForwardRef as ReactComponent };